import EmployeesRegistration from './EmployeesRegistration';

export default EmployeesRegistration;
